<template>
  <div>
    <base-header class="pb-6" type="primary">
      <breadcrumb-header :items="breadcrumb"></breadcrumb-header>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbHeader from "@/views/Store/Layout/BreadcrumbHeader";

export default {
  name: 'OperatorView',
  components: {
    BreadcrumbHeader,
  },
  computed: {
    breadcrumb() {
      return [
        {title: 'Administracja', link: {name: 'administration'}},
        {title: 'Operatorzy', link: {name: 'operator-list'}},
        {title: `Operator ID: ${this.$route.params.id}`}
      ];
    },
  },
};
</script>
